import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router';
import { Header, Sidebar } from "../../Layout";
import Approvers from "../Approvers";
import SupportingDocument from "../SupportingDocuments";
import Timelines from "../Timelines";
import ProjectPlanning from '../ProjectPlanning'
import { editProject, getProjectScheduleDetail, getProjectTimelins, getAllProjectsApprovers} from '../../../actions/projectActions';
import { timelineAllStages } from '../../../actions/projectTimelineActions'
import { useDispatch, useSelector } from "react-redux";
import ProjectStage from '../ProjectStage';

const ProjectDetails = (props) => {

    const history = useHistory()
    const [projectId , setProjectId] = useState();
    // const [currentStage , setCurrentStage] = useState();
    const [currentTab , setCurrentTab] = useState();
    const dispatch = useDispatch();
    const {project, project_schedule, projectApprovers} = useSelector(state => state.projectStore);
    const { timelineStages } = useSelector(state => state.timelinesStore)
    useEffect(() => {
        const id = props?.match?.params?.id;
        if (id) {
            setProjectId(id);
            dispatch(getProjectScheduleDetail(id))
            dispatch(getProjectTimelins(id))
            dispatch(getAllProjectsApprovers(id))
            dispatch(editProject(id))
            dispatch(timelineAllStages(id))
        } 
        else history.push('/dashboard');
    }, [dispatch, history, props])

    useEffect(() => {
    },[timelineStages])
    return (
        <>
            <Header />
            <Sidebar />
            <div id="main-content">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Project Details</h2>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"><i className="icon-home"></i></Link></li>
                                <li className="breadcrumb-item active">Projects</li>
                                <li className="breadcrumb-item active">Project Details</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                        <div className="col-lg-12 col-md-12">
                            <div className="card">
                                <div className="header">
                                    <h3>{project_schedule?.title}</h3>
                                    <div className="header-dropdown dropdown dropdown-animated scale-left ">
                                        <h3>{project_schedule?.job_number}</h3>
                                    </div>
                                </div>
                                <div className="body">
                                    <ul className="row nav nav-tabs custom_nav_tabs">
                                        <li className="nav-item"><a className="nav-link text-center active show" data-toggle="tab" href="#Home">Briefing</a></li>
                                        <li className="nav-item"><a className="nav-link text-center" data-toggle="tab" href="#Timeline">Timeline</a></li>
                                        {timelineStages && timelineStages.map((stage, index) => (
                                            <li key={index} className="nav-item"><a className="nav-link text-center" data-toggle="tab" onClick={() => setCurrentTab(stage.id)} href={`#Id${stage.id}`}>{stage.strategy}</a></li>
                                        ))}
                                    </ul>
                                    <div className="tab-content mt-4">
                                        <div className="tab-pane show active" id="Home">
                                            <Timelines project={project_schedule} />
                                            {/* <Chat /> */}
                                            <Approvers approver={projectApprovers} />
                                            <SupportingDocument projectsId={projectId} />
                                        </div>
                                        <div className="tab-pane" id="Timeline">
                                            <ProjectPlanning timelines={timelineStages} />
                                        </div>
                                        {
                                            timelineStages && timelineStages.map((stages, index) => {
                                                if (stages.id === currentTab) {
                                                    return (
                                                        <div key={index} className="tab-pane" id={`Id${stages?.id}`}>
                                                            <ProjectStage data={project} stage={stages} />
                                                        </div>
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ProjectDetails;